import React from 'react'
import {Popover} from '@material-ui/core'
import './PopSelect.scss'

const PopSelect = ({open = false, anchorEl = null, children, onClose = e => {}}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableScrollLock={true}
      classes={{
        paper: '',
      }}
      className={`c-res-mod ap-pop-select`}
    >
      <div className={'ap-pop-select__wrapper ap-scrollbar'}>{children}</div>
    </Popover>
  )
}

export default PopSelect
